import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['group', 'listings'];

  connect() {
    this.updateLastCardListener();
  }

  updateLastCardListener() {
    const eventCards = this.element.querySelectorAll('.event_card');
    const lastEventCard = eventCards[eventCards.length - 1];
    if (lastEventCard) {
      lastEventCard.addEventListener('eventCardProcessed', this.handleLastEventCardProcessed);
    }
  }

  disconnect() {
    const eventCards = this.element.querySelectorAll('.event_card');
    const lastEventCard = eventCards[eventCards.length - 1];
    if (lastEventCard) {
      lastEventCard.removeEventListener('eventCardProcessed', this.handleLastEventCardProcessed);
    }
  }

  handleLastEventCardProcessed = () => {
    this.checkGroups();
    this.updateListingsVisibility();
  };

  checkGroups() {
    let anyGroupHasVisibleCards = false;

    this.groupTargets.forEach((group) => {
      const hasVisibleCards = group.querySelectorAll('.event_card').length > 0;
      if (hasVisibleCards) {
        anyGroupHasVisibleCards = true;
      } else {
        group.remove();
      }
    });

    document.querySelector('.js-no-events').classList.toggle('-show', !anyGroupHasVisibleCards);
    this.dispatchCompletedEvent();
  }

  dispatchCompletedEvent() {
    const event = new CustomEvent('eventGroupProcessed', { bubbles: true });
    this.element.dispatchEvent(event);
  }

  updateListingsVisibility() {
    this.listingsTarget.classList.remove('hidden-content');
  }
}
